import Path from "src/constants/path";
import { SignupCustomCampaignName } from "src/ui/components/SignupCustomContent/SignupCustom.types";

const linkedPaths = [
  `/${Path.auth}/${Path.authOneTimeTokenApp}`,
  `/${Path.authRegisterAlternative}/${SignupCustomCampaignName.PersonifyHealth}`
];

const isLinkedPath = (pathname: string): boolean =>
  pathname === `/${Path.app}` ||
  pathname.startsWith(`/${Path.app}/`) ||
  linkedPaths.includes(pathname);

export const getAppPathFromUrl = (url: string): string | undefined => {
  try {
    const { pathname, search, hash } = new URL(url);
    return isLinkedPath(pathname) ? `${pathname}${search}${hash}` : undefined;
  } catch {
    return undefined;
  }
};
